/**
 * State formation processing times based on Secretary of State data.
 * Source: https://collectivehub.atlassian.net/browse/HUB-2078
 */
export const STATE_FORMATION_PROCESSING_TIMES_IN_BUSINESS_DAYS: Record<string, string> = {
    AK: '1-7',
    AL: '1-3',
    AR: '3-7',
    AZ: '2-6',
    CA: '2-3',
    CO: '1',
    CT: '2-3',
    DC: '5',
    DE: '2-3',
    FL: '5',
    GA: '7-10',
    HI: '44',
    IA: '1',
    ID: '2-3',
    IL: '10',
    IN: '1',
    KS: '1',
    KY: '1',
    LA: '3-5',
    MA: '1-2',
    MD: '8-11',
    ME: '2-3',
    MI: '2-3',
    MN: '1',
    MO: '1',
    MS: '1-2',
    MT: '2-3',
    NC: '5-10',
    ND: '5',
    NE: '2-3',
    NH: '7-10',
    NJ: '2-4',
    NM: '1-3',
    NV: '1',
    NY: '2-3',
    OH: '1',
    OK: '2-3',
    OR: '2-3',
    PA: '5',
    RI: '3-4',
    SC: '2-4',
    SD: '1',
    TN: '1',
    TX: '10-15',
    UT: '1',
    VA: '2-5',
    VT: '1',
    WA: '5',
    WI: '1',
    WV: '2-3',
    WY: '1',
};

const DEFAULT_PROCESSING_TIME = '5-7';

// Returns a grammatically correct phrase describing the state's formation processing time.
export const getProcessingTimePhrase = (state?: string): string => {
    const days = STATE_FORMATION_PROCESSING_TIMES_IN_BUSINESS_DAYS[state || ''] || DEFAULT_PROCESSING_TIME;
    const unit = days === '1' ? 'business day' : 'business days';

    return `${days} ${unit}`;
};
